// tslint:disable
import { get } from 'lodash';
import * as React from 'react';
import { InputField } from '../../components/fields/input.field';
import { ConsoleLib } from '../../components/libs/console.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ListConsole } from '../../components/structurals/list-console';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import * as moment from "moment";
import {Notification} from "../../index";
import axios from "axios";
import {Environment} from "../../environment/environment";

export class DefaultMainCarouselList extends React.Component<any, any> {

    async handleItemDelete(item: any, list: ListLib, listActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        list.isLoading$.next(true);
        await listActions.delete(item['@id']);
        list.refetch();
    }

    render() {
        return (
            <ListResourceLoader forceQuery={{'pagination': 'false'}} entity="main-carousel" render={(list: ListLib, raw: any) => <div>
                <div id="page-title">
                    <h2>
                        Main Carousel
                        <div className="pull-right">
                            <a href="/main-carousel/create" className='btn btn-sm btn-primary'>Create new Carousel item</a>
                        </div>
                    </h2>
                    <p></p>
                </div>

                <ListConsole
                    className="col-xs-12 col-lg-3 pull-right"
                    config={list.console}
                    render={(console: ConsoleLib) => <div>
                        <InputField field={console.setQuery('title', {title: 'Search in title', placeholder: 'some keyword'})}/>
                    </div>}
                />

                <div className="col-xs-12 col-lg-9 pull-left relative">
                    <LoaderComponent isLoading$={list.isLoading$}/>

                    <ListResponsePresenterTable
                        items={list.member}
                        head={() => {
                            return (
                                <tr>
                                    <th>#</th>
                                    <th>Title</th>
                                    <th>Position</th>
                                    <th>Enabled</th>
                                    <th>PublishedAt</th>
                                    <th>DeletedAt</th>
                                    <th></th>
                                </tr>
                            );
                        }}
                        row={(item: any, index: number, actions: ListActions) => {
                            return (
                                <tr key={index}>
                                    <td>{get(item, 'id', '-')}</td>
                                    <td>{get(item, 'title', '-')}</td>
                                    <td>{get(item, 'position', '-')}</td>
                                    <td>
                                        {get(item, 'enabled') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'publishedAt') ? moment(get(item, 'publishedAt')).format('DD/MM/Y H:mm') : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        {get(item, 'publishedAt') ? moment(get(item, 'publishedAt')).format('DD/MM/Y H:mm') : <span className="bs-label label-danger">No</span>}
                                    </td>
                                    <td>
                                        <button className="btn btn-xs btn-primary" onClick={() => actions.open(item['@id'])}>View details</button> &nbsp;
                                        <a onClick={(event: any) => this.handleDelete(item)} className="btn btn-warning btn-xs" href="#">
                                            Delete item
                                        </a>
                                    </td>
                                </tr>
                            );
                        }}/>

                    {/*<Pagination config={list.pagination}/>*/}
                </div>
            </div>}
            />
        );
    }


    private async handleDelete(item: any) {

console.log(item)
        const answer = await Notification.delete();

        if (answer === true) {
            try {
                await axios.delete(`${Environment.get('api.base')}${item['@id']}`, {withCredentials: true});
                Notification.notify({
                    title: 'Delete is successful',
                    timer: 3000
                });

                window.location.href = '/main-carousel';
            } catch (error) {
                Notification.error('Error', error.message);
                false;
            } finally {

            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/__templates/lists/default.main-carousel.list.tsx